import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { createHead } from '@unhead/vue/client';
import { TemplateParamsPlugin } from '@unhead/vue/plugins';
import { vuetify } from '@/plugins/vuetify';
import './styles/main.scss';
import { i18n } from '@/plugins/i18n';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { initDatadog } from '@/plugins/datadog';
import { initAxios } from '@/plugins/axios';
import { LicenseManager } from 'ag-grid-enterprise';
import appConfig, { type GmAppConfig } from '@/app.config';
import '/node_modules/@teamworksdev/vuetify/dist/src/styles/main.scss';
import { LDPlugin } from 'launchdarkly-vue-client-sdk';
import { initRemotes } from './plugins/mfes';
import { initMaven } from './plugins/maven';
import { initCustomerIo } from '@/plugins/customerio';


initDatadog();

initAxios();

initRemotes();

initMaven();

initCustomerIo();

if (import.meta.env.VITE_AG_GRID_LICENSE_KEY) {
  LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY);
}

const app = createApp(App);
const pinia = createPinia();

const head = createHead({
  plugins: [TemplateParamsPlugin],
});

if (import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID) {
  app.use(LDPlugin, {
    context: {
      anonymous: true,
      kind: 'user',
      key: 'gm-launchdarkly-anonymous-user',
    },
    clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
    options: {
      sendEventsOnlyForVariation: true,
    },
  });
}

import { queryClient } from '@/plugins/vueQuery';

app
  .use(head)
  .use(VueQueryPlugin, { queryClient })
  .use(i18n)
  .use(pinia)
  .use(vuetify)
  .use(router)
  .provide<GmAppConfig>('appConfig', appConfig)
  .mount('#app');
